import React from 'react';
import './style.css';

import Icon from 'react-web-vector-icons';

import { Grid } from '@material-ui/core';

import images from '../../services/imagesInBase64';

import logo from '../../images/home/logo-city-frase-reg-branco.png';
import logoUs from '../../images/home/logo-us.png';
import us from '../../images/home/us-flag.png';
import brazil from '../../images/home/brazil-flag.png';
import logoNextcloud from '../../images/home/logo-white.png';

import { Title, Divider } from '../common/styled';

import mediaQuery from '../common/mediaQuery';

// componentes
import NavMenu from '../common/nav';
import Form from '../common/form';

import { bounceInLeft } from 'react-animations';
import styled, { keyframes } from 'styled-components';
import FormMobile from '../common/FormMobile';
import PayPalLogo from '../../images/paypal-donate.png';

const bounceLeft = keyframes`${bounceInLeft}`;
const BounceLeft = styled.div`
  animation: 1.5s ${bounceLeft};
`;

export default ({ text, handleLanguage, language }) => {
  const { large, medium, small } = mediaQuery();

  return (
    <div className="App" style={{ marginBottom: '15vh' }}>
      <header className="App-header">
        <div
          className={
            small ? 'App-header-background-1-mobile' : 'App-header-background-1'
          }
        >
          {small && language === 'br' && (
            <div className="formMobileContainer">
              {' '}
              <FormMobile text={text} />{' '}
            </div>
          )}

          <Grid
            container
            justify="center"
            alignItems="center"
            className="Header-espacamento"
          >
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              item
              xs={4}
              sm={4}
            >
              <a
                href="https://www.instagram.com/cityconnectbroficial/"
                target="_blank"
              >
                <Icon
                  name="instagram"
                  font="FontAwesome"
                  size={30}
                  color="#fff"
                  style={{ marginRight: 10 }}
                />
              </a>

              <a
                href="https://www.facebook.com/CityConnectBROficial/"
                target="_blank"
              >
                <Icon
                  name="facebook-f"
                  font="FontAwesome"
                  size={30}
                  color="#fff"
                  style={{ marginRight: 10 }}
                />
              </a>

              <a
                href="https://www.linkedin.com/company/cityconnectbr/mycompany/"
                target="_blank"
              >
                <Icon
                  name="linkedin"
                  font="FontAwesome"
                  size={30}
                  color="#fff"
                />
              </a>

              <a
                className="logoNextcloud"
                href="https://nextcloud.cityconnect.com.br/login"
                target="_blank"
              >
                <img src={logoNextcloud} alt="Nextcloud" />
              </a>
            </Grid>

            <Grid
              item
              container
              xs={8}
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              {large && language === 'br' && (
                <>
                  {' '}
                  <Form text={text} /> <Divider width="6vw" />{' '}
                </>
              )}

              {language === 'us' && (
                <form
                  className="PaypalForm"
                  action="https://www.paypal.com/cgi-bin/webscr"
                  method="post"
                  target="_top"
                >
                  <input type="hidden" name="cmd" value="_s-xclick" />
                  <input
                    type="hidden"
                    name="hosted_button_id"
                    value="3C8WF4HRLCHXS"
                  />
                  <input
                    type="image"
                    class="PayInput"
                    style={small ? { width: '30vw' } : {}}
                    src={PayPalLogo}
                    border="0"
                    name="submit"
                    alt="PayPalc - The safer, easier way to pay online!"
                  />
                </form>
              )}

              <img
                onClick={() => handleLanguage('us')}
                src={us}
                className="Header-flags"
                alt=""
                style={{ cursor: 'pointer' }}
              />
              <img
                onClick={() => handleLanguage('br')}
                src={brazil}
                className="Header-flags"
                alt=""
                style={{ cursor: 'pointer' }}
              />
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className="Header-menu"
          >
            <Grid item sm={2} xs={5}>
              <img
                src={language === 'br' ? logo : logoUs}
                className="Header-logo"
                alt=""
              />
            </Grid>

            <NavMenu language={language} />
          </Grid>

          <Grid
            container
            spacing={1}
            direction="row"
            justify="center"
            alignItems="center"
            className="responsiveHeaderGrid"
            style={{ marginTop: 50 }}
          >
            <Grid item xs={12} sm={6}>
              {' '}
              {/* JÃO */}
              <img
                src={
                  language === 'br'
                    ? images.computador_br
                    : images.computador_us
                }
                className={
                  large
                    ? 'Header-computador'
                    : medium
                    ? 'Header-computador'
                    : small
                    ? 'Header-computador-mobile'
                    : 'Header-computador-mobile'
                }
                alt=""
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
              container
              justify="center"
              alignItems="flex-end"
            >
              <BounceLeft>
                <Title
                  transform="uppercase"
                  size={
                    large ? '4.5vh' : medium ? '4vh' : small ? '3vh' : '3vh'
                  }
                  weight="1000"
                  lineHeight="8vh"
                  marginTop="10vh"
                  padding={small ? '0 5vw' : '0'}
                  align={small ? 'center' : 'left'}
                  borderText
                  style={{ marginTop: 0 }}
                >
                  {text.getTextoHeader()}
                </Title>
              </BounceLeft>
            </Grid>
            {/* <Grid item xs={12} sm={6}>
              <img
                src={language === 'br' ? images.computador_br : images.computador_us }
                className={
                  large
                    ? "Header-computador"
                    : medium
                    ? "Header-computador"
                    : small
                    ? "Header-computador-mobile"
                    : "Header-computador-mobile"
                }
                alt=""
              />
            </Grid> */}
          </Grid>
        </div>
      </header>
    </div>
  );
};
